import styled from '@emotion/styled';
import SafeImage from 'components/SafeImage';
import { HTMLAttributes, ReactNode } from 'react';
import { css, cx } from '@emotion/css';

export interface ItemProps extends HTMLAttributes<HTMLDivElement> {
  item: Pick<Knowledge.SPU.Spu, 'imageUrl' | 'title' | 'itemUrl'>;
  width?: number;
  extra?: ReactNode;
  operation?: ReactNode;
  titleLine?: number;
}

function Item(props: ItemProps) {
  const {
    item: { imageUrl, title, itemUrl },
    width = 48,
    extra,
    operation,
    titleLine = 1,
  } = props;

  return (
    <Container width={width}>
      <div
        className={cx(
          'main',
          css`
            .ant-image-mask {
              .ant-image-mask-info {
                font-size: 0 !important;
                & > span {
                  font-size: 14px !important;
                  margin-inline-end: unset !important;
                }
              }
            }
          `,
        )}
      >
        <SafeImage preview src={imageUrl} width={width} />
        <section>
          <a
            className={titleLine === 2 ? 'line-clamp-2' : 'line-clamp-1'}
            href={itemUrl}
            target="__blank"
          >
            {title}
          </a>
          {extra}
        </section>
      </div>
      {operation}
    </Container>
  );
}

const Container = styled.div<{ width: string | number }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
  .main {
    display: flex;
    overflow: hidden;
    > div {
      flex: 0 0 auto;
      width: ${({ width }) => `${width}px`};
      height: ${({ width }) => `${width}px`};
      margin-right: 6px;
    }
    section {
      flex: 1 0 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      gap: 4px;
      font-size: 12px;
      overflow: hidden;
      > a {
        text-overflow: ellipsis;
        color: #515359;
        &:hover {
          color: var(--ant-primary-color);
        }
      }
      > * {
        max-width: 100%;
      }
    }
  }
`;

export default Item;
